
import { createVNode, render } from 'vue'
import Popup from '@components/popup.vue'

const popup = (msg) => {
  return new Promise((resolve, reject) => {
    // 既存 popup があれば削除
    const existedPopupEl = document.getElementById('popup-container')
    if (existedPopupEl) {
      render(null, existedPopupEl)
      document.body.removeChild(existedPopupEl)
    }

    // mount 用 container
    const container = document.createElement('div')
    container.id = 'popup-container'
    document.body.appendChild(container)

    // 初期値補正
    if (!msg.position && msg.position !== 0) {
      msg.position = 'middle'
    }

    if (!msg.btn) {
      msg.btn = {
        cancel: '',
        apply: '',
        confirm: 'OK',
      }
    }

    if (!msg.btnStyle) {
      msg.btnStyle = {
        panel: {},
        cancel: {},
        apply: {},
        confirm: {},
      }
    }

    // Popup VNode 作成
    const vnode = createVNode(Popup, {
      msg,
      onCancel: (res) => {
        console.log("popup:cancel")
        reject(res)
        msg.cancel?.()
        vnode.component.exposed?.close()
        render(null, container)
        document.body.removeChild(container)
      },
      onApply: (res) => {
        console.log("popup:apply")
        resolve(res)
        msg.apply?.()
        vnode.component.exposed?.close()
        render(null, container)
        document.body.removeChild(container)
      },
      onConfirm: (res, event) => {
        console.log("popup:confirm")
        resolve(res)
        msg.confirm?.()

        if (!msg.noCloseFlag) {
          vnode.component.exposed?.close()
          queueMicrotask(() => {
            render(null, container)
            container.remove()
          })
        }

        if (msg.url) {
          if (
            (
              msg.url.includes('search-result') ||
              msg.url.includes('brand-facility') ||
              msg.url.includes('newend-facility') ||
              msg.url.includes('searchTag-facility') ||
              msg.url === '/'
            ) &&
            msg.loginurl !== ''
          ) {
            event?.preventDefault()
            location.href = msg.loginurl
          }
        }
      },
    })

    // render
    render(vnode, container)
  })
}

export default popup
